import css from '@styled-system/css'
import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { variant } from 'styled-system'

import { Flex, Icon } from '../atoms'
import { IconsTheme } from '../icons'

export type HelpTextProperty = 'default'

export interface MenuTextProps {
  variant?: HelpTextProperty
}

const MenuText = styled.div<MenuTextProps>(
  css({
    display: ['none', 'none', 'block'],
  }),
  variant({
    scale: 'HelpText',
    variants: {
      default: {
        ml: 2,
      },
    },
  }),
)

MenuText.defaultProps = {
  variant: 'default',
}

export interface MenuItemProps {
  icon?: keyof IconsTheme
  text?: string
}

export const MenuItem: FunctionComponent<MenuItemProps> = ({ text, icon = 'chat' }) => {
  return (
    <Flex>
      <Icon icon={icon} size='small' />
      {text && <MenuText>{text}</MenuText>}
    </Flex>
  )
}
